import React from 'react';
import { Link } from 'react-router-dom';

function Seguranca() {
  return (
    <div className="container text-light mt-5 px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="mb-3 text-white text-center">
          <i className="bi bi-shield-lock-fill me-2 text-danger"></i>
          Segurança da Informação
        </h2>

        <p className="text-white-50 text-center mb-4">
          A <strong>InfoService</strong> implementa políticas e soluções robustas para proteger sua empresa contra ameaças internas e externas, com foco em prevenção, controle e resposta rápida a incidentes.
        </p>

        <ul className="text-light fs-6">
          <li className="mb-3">
            <i className="bi bi-lock-fill me-2 text-primary"></i>
            <strong>Controle de acesso:</strong> Firewalls UTM, regras de acesso por função, autenticação multifator e segmentação lógica.
          </li>

          <li className="mb-3">
            <i className="bi bi-virus2 me-2 text-success"></i>
            <strong>Proteção contra malware:</strong> Soluções EDR (Endpoint Detection & Response), antivírus corporativo e atualizações automáticas.
          </li>

          <li className="mb-3">
            <i className="bi bi-file-earmark-lock-fill me-2 text-warning"></i>
            <strong>Proteção de dados:</strong> Políticas de backup, criptografia, retenção e classificação de dados sensíveis.
          </li>

          <li className="mb-3">
            <i className="bi bi-lightning-fill me-2 text-info"></i>
            <strong>Resposta a incidentes:</strong> Monitoramento contínuo, logs centralizados, análise de eventos e plano de contenção de danos.
          </li>
        </ul>

        <div className="mt-4 text-center">
          <Link to="/contato" className="btn btn-outline-danger btn-lg px-4">
            Consultar soluções de segurança
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Seguranca;
